// extracted by mini-css-extract-plugin
export default {"base":"Spinner_base__oPVsE","spinner":"Spinner_spinner__VFxrJ","spin":"Spinner_spin__HVGyw","logo":"Spinner_logo__b8ijQ"};